window.ExpirationModal = null;
window.WarningBeforeExpirationModal = null;
window.ExpirationDateTime = null;
window.WarningBeforeExpirationTriggered = false;
window.Timer = null;
window.ModalText = null;

window.InitExpirationTimer = function (datetime) {
    if (ExpirationDateTime == null) {
        ExpirationDateTime = new Date(datetime).getTime();
        SetTimerInterval();
    }
}

window.CheckTimer = function () {
    const now = new Date().getTime();

    const timeRemaining = ExpirationDateTime - now;

    if (WarningBeforeExpirationTriggered) {
        UpdateRemainingTimeString();
    }

    if (timeRemaining <= 3 * 60 * 1000 && !WarningBeforeExpirationTriggered) {
        WarningBeforeExpirationTriggered = true;
        OpenWarningBeforeExpirationModal();
    }
    //if less than 3 seconds left
    if (timeRemaining < 3000) {
        clearInterval(Timer);
        CloseModal(WarningBeforeExpirationModal);
    }
}


window.SetTimerInterval = function () {
    const now = new Date().getTime();
    
    const timeRemaining = ExpirationDateTime - now;

    //if more than a day remaining, check after a day
    if (timeRemaining > 24 * 60 * 60 * 1000) {
        Timer = setTimeout(SetTimerInterval, 24 * 60 * 60 * 1000); 
    } 
    //if more than an hour remaining, check after an hour
    else if (timeRemaining > 60 * 60 * 1000) {
        Timer = setTimeout(SetTimerInterval, 60 * 60 * 1000); 
    }
    //if more than 10 minutes remaining, check after a minute
    else if (timeRemaining > 5 * 60 * 1000) {
        Timer = setTimeout(SetTimerInterval, 60 * 1000); 
    }
    //if less than 5 minutes remaining, start timer
    else if (timeRemaining <= 5 * 60 * 1000 && timeRemaining > 0) {
        Timer = setInterval(CheckTimer, 1000); 
    }
}

window.OpenExpiredModal = function () {
    if (ExpirationModal == null) {
        $.ajax({
            url: "CheckoutModal/purchaseExpired",
            type: "GET",
            success: function (html) {

                ExpirationModal = $(html)[0];
                $("#js-modal").append(ExpirationModal);
                OpenModal(ExpirationModal);
            },
            error: function (xhr, status, error) {
                alert('The purchase was cancelled due to inactivity. Please make a new purchase.');
                CloseExpirationModal();
            }
        })
    }
    else {
        $("#js-modal").append(ExpirationModal);
        OpenModal(ExpirationModal);
    }
}

window.CloseExpirationModal = function () {
    CloseModal(ExpirationModal);

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    location.href = urlParams.get('cancelPurchaseCallbackUrl');
}

window.OpenWarningBeforeExpirationModal = function () {
    if (WarningBeforeExpirationModal == null) {
        $.ajax({
            url: "CheckoutModal/warningPurchaseExpiration",
            type: "GET",
            success: function (html) {

                WarningBeforeExpirationModal = $(html)[0];
                $("#js-modal").append(WarningBeforeExpirationModal);
                UpdateRemainingTimeString();
                OpenModal(WarningBeforeExpirationModal);
            },
            error: function (xhr, status, error) {
                alert('Your purchase reservation is about to expire. You have only 3 minutes to complete the payment.');
            }
        })
    }
    else {
        $("#js-modal").append(WarningBeforeExpirationModal);
        UpdateRemainingTimeString();
        OpenModal(WarningBeforeExpirationModal);
    }
}

window.UpdateRemainingTimeString = function() {
    const now = new Date().getTime();
    const timeRemaining = ExpirationDateTime - now;

    const minutes = Math.floor(timeRemaining / (1000 * 60)); 
    let seconds = Math.round((timeRemaining % (1000 * 60)) / 1000 / 5) * 5;

    if (seconds === 60) {
        seconds = 55;
    }

    if (ModalText == null) {
        ModalText = $(WarningBeforeExpirationModal).find('.modal-body p').html();
    }
    let newModalText;
    if (ModalText) {
        newModalText = ModalText.replace("{0}", minutes).replace("{1}", seconds);

        $(WarningBeforeExpirationModal).find('.modal-body p').html(newModalText);
    }   

}
